import { api } from './client';

export interface StateRow {
  code: string;
  name: string;
}

export interface HsnRow {
  code: string;
  description: string | null;
  defaultGst: number | null;
}

export async function fetchMasterList(listKey: string): Promise<string[]> {
  const r = await api.get<string[]>(`/masters/lists/${listKey}`);
  return r.data;
}

export async function fetchAllMasterLists(): Promise<{ key: string; values: string[] }[]> {
  const r = await api.get<{ key: string; values: string[] }[]>(`/masters/lists`);
  return r.data;
}

export async function addMasterValue(listKey: string, value: string): Promise<void> {
  await api.post(`/masters/lists/${listKey}`, { value });
}

export async function deleteMasterValue(listKey: string, value: string): Promise<void> {
  await api.delete(`/masters/lists/${listKey}/${encodeURIComponent(value)}`);
}

export async function clearMasterList(listKey: string): Promise<void> {
  await api.delete(`/masters/lists/${listKey}`);
}

export async function fetchStates(): Promise<StateRow[]> {
  const r = await api.get<StateRow[]>(`/masters/states`);
  return r.data;
}

export async function searchHsnCodes(q?: string): Promise<HsnRow[]> {
  const r = await api.get<HsnRow[]>(`/masters/hsn-codes`, { params: q ? { q } : {} });
  return r.data;
}
